import { gql } from "@apollo/client";

export const GET_WAREHOUSES = gql`
  {
    warehouse {
      list {
        warehouses {
          name
          code
          id
          branchID
          regionID
          type
          branch {
            id
            name
          }
          ward {
            name
          }
          city {
            name
          }
          address
        }
      }
    }
  }
`;

export const GET_WAREHOUSES_BY_SELLER = gql`
  query GetWarehousesBySeller($sellerID: ID!) {
    warehouse {
      list(request: { seller_id: $sellerID }) {
        warehouses {
          id
          name
          type
          address
          branch {
            id
            name
          }
          city {
            name
          }
          district {
            name
          }
          ward {
            name
          }
        }
      }
    }
  }
`;
